import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { setSelectedDealer } from "components";
import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { Dealer } from "models";

export const useAcceptApiAgreementMutation = () => {
  const { t } = useTranslation();

  return useTypedMutation<Dealer, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/dealers/update", payload, ENV.dealerBaseURL);
    },
    onSuccess: updatedDealer => {
      setSelectedDealer(updatedDealer);
      toast.success(t("v8_api_agreement_accepted", "API agreement accepted"));
    }
  });
};
